export default __webpack_public_path__ + "static/media/2_0126.5660eb1a.webp";